export default "__VITE_ASSET__6D_lWoD5__"